<template lang="pug">
.home
	img(src="../assets/images/vintage-test-three.jpg" id="bg")
	.hero-text
		h1 Transistor Sister
		h2 Again With the Twister
		h3 Megawatt Mecca
		a.btn.btn-secondary.btn-lg.mt-3(href='/automotive') McLuhan To The Moon 
//- .container
//- 	.d-flex.flex-wrap.justify-content-around
//- 		.card.bg-secondary.text-white.my-5(style='width: 18rem;')
//- 			img.card-img-top(src='../assets/images/marconi-radio-two.jpg' alt='Phoney Marconi Trombone')
//- 			.card-body
//- 				h5.card-title Amplitude Modulation
//- 				p.card-text Νε vελ ομνεσ φαβθλασ. Cορπορα cοπιοσαε ρεφορμιδανσ ναμ θτ. Vισ ιν μανδαμθσ ινcορρθπτε. Vιμ ωισι οφφενδιτ ρεφορμιδανσ τε, ατqθι νονθμυ πθτεντ νο qθι, vελ αδ ενιμ vερι φαλλι. Περ πορρο ελειφενδ cθ, δενιqθε μολεστιαε ιδ προ.
//- 				p.text-center
//- 					a.btn.btn-light.btn-md.mr-3(href='/about') Marconi
//- 					a.btn.btn-dark.btn-md(href='/about') Trombone


//- 		.card.my-5(style='width: 18rem;')
//- 			img.card-img-top(src='../assets/images/marconi-radio-two.jpg' alt='Phoney Marconi Trombone')
//- 			.card-body
//- 				h5.card-title Frequemcy Modulation
//- 				p.card-text Νε vελ ομνεσ φαβθλασ. Cορπορα cοπιοσαε ρεφορμιδανσ ναμ θτ. Vισ ιν μανδαμθσ ινcορρθπτε. Vιμ ωισι οφφενδιτ ρεφορμιδανσ τε, ατqθι νονθμυ πθτεντ νο qθι, vελ αδ ενιμ vερι φαλλι. Περ πορρο ελειφενδ cθ, δενιqθε μολεστιαε ιδ προ.
//- 				p.text-center
//- 					a.btn.btn-secondary.btn-md.mr-3(href='/about') Marconi
//- 					a.btn.btn-outline-dark.btn-md(href='/about') Trombone



//- 		.card.my-5(style='width: 18rem;')
//- 			img.card-img-top(src='../assets/images/marconi-radio-two.jpg' alt='Phoney Marconi Trombone')
//- 			.card-body
//- 				h5.card-title Megaherz and Gigaherz 
//- 				p.card-text Νε vελ ομνεσ φαβθλασ. Cορπορα cοπιοσαε ρεφορμιδανσ ναμ θτ. Vισ ιν μανδαμθσ ινcορρθπτε. Vιμ ωισι οφφενδιτ ρεφορμιδανσ τε, ατqθι νονθμυ πθτεντ νο qθι, vελ αδ ενιμ vερι φαλλι. Περ πορρο ελειφενδ cθ, δενιqθε μολεστιαε ιδ προ.
//- 				p.text-center
//- 					a.btn.btn-secondary.btn-md.mr-3(href='/about') Marconi
//- 					a.btn.btn-outline-dark.btn-md(href='/about') Trombone

</template>	

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
	name: 'Home',
	components: {
		HelloWorld
	}
}
</script>

<style>

@import "../assets/stylings/engines.css";

body, html {
	height: 100%;
}
</style>